"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.default = (function (_a) {
    var validate = _a.validate, validateSchema = _a.validateSchema, required = _a.required;
    var validateFn = react_1.useMemo(function () {
        if (validateSchema) {
            return function (value) {
                return validateSchema
                    .validate(value)
                    .then(function () { return undefined; })
                    .catch(function (err) { return err.message; });
            };
        }
        if (validate) {
            return validate;
        }
        if (required) {
            return function (value) {
                if (value === undefined) {
                    return 'ui.commons.required';
                }
                return undefined;
            };
        }
        return function () { return undefined; };
    }, [validate, validateSchema, required]);
    return [validateFn];
});
